import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVerifiedStyle0 = cosmosIconCss;

const CosmosIconVerified$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVerified extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'df289f3e9528d355a3457f16ad302b1a5c43bfc1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '50f98b904b67af7978c9e3ef7ccf74ae38cc30ca', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a536b77988f10502ce9b0956732d2d34458f77fd', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.51 2a.5.5 0 0 0-.5.5V3c0 9.82 2 13.83 7.76 16.87a.56.56 0 0 0 .49 0C17.05 16.87 19 12.81 19 3v-.5a.5.5 0 0 0-.5-.5H3.51ZM17.5 3.5c-.07 9.36-2.17 12.5-6.5 14.8-4.32-2.42-6.44-5.53-6.5-14.8h13ZM7 10.44l3.35 2.85a.49.49 0 0 0 .72-.09l4.33-5.81a.5.5 0 0 0-.1-.7l-.4-.3a.5.5 0 0 0-.7.11l-3.64 5-2.53-2.15a.51.51 0 0 0-.71 0L7 9.73a.51.51 0 0 0 0 .71Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVerifiedStyle0; }
}, [1, "cosmos-icon-verified", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-verified"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-verified":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVerified$1);
            }
            break;
    } });
}

const CosmosIconVerified = CosmosIconVerified$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVerified, defineCustomElement };
